import { Injectable, Injector } from "@angular/core";
import { TrackingDispatchService } from "./tracking-dispatch.service";
import { InteractionEventRequest, InteractionType } from "./tracking.models";

// Re-exported so the ~20 call sites that import InteractionType from here keep working. The
// definitions moved to tracking.models.ts to break an import cycle with TrackingDispatchService.
export { InteractionEventRequest, InteractionType };

/**
 * Records in-page interactions — actions a user takes within a screen that don't change the route
 * (add/edit/delete an item, clear-all, a dialog confirmation). Distinct from
 * NavigationTrackingService, which covers route-to-route transitions. See "Full App Event-Tracking
 * Taxonomy" (Confluence FLIP-110919682).
 *
 * Since FLIP-213 this only queues onto TrackingDispatchService, which batches everything fired in
 * the same tick into one POST to api/Tracking/Track. The public signature is unchanged, so no call
 * site needed touching.
 */
@Injectable({
  providedIn: "root",
})
export class InteractionTrackingService {
  // Resolved lazily via Injector so a component injecting only this service doesn't drag
  // UserService (a TrackingDispatchService dependency) into its construction order.
  constructor(private injector: Injector) {}

  /** Fire-and-forget: tracking must never block or break the interaction if it fails. */
  track(event: InteractionEventRequest): void {
    this.injector.get(TrackingDispatchService).queueInteraction(event);
  }
}
